// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { deviceChannelDatatypeEnum } from './DeviceChannelDatatypeEnum';
import { deviceChannelRoleEnum } from './DeviceChannelRoleEnum';
import { deviceModelChannelId } from './DeviceModelChannel';
import { timeseriesSeriesId } from './TimeseriesSeries';
import { z } from 'zod';
export const deviceChannelId = (z.number());
export const deviceChannel = z.object({
    id: deviceChannelId,
    device_id: deviceId,
    key: z.string(),
    label: z.string(),
    datatype: deviceChannelDatatypeEnum,
    unit: z.string().nullable(),
    role: deviceChannelRoleEnum,
    created_at: z.date(),
    updated_at: z.date(),
    kind: z.string(),
    description: z.string().nullable(),
    min_value: z.number().nullable(),
    max_value: z.number().nullable(),
    default_value: z.number().nullable(),
    is_active: z.boolean(),
    last_seen_at: z.date().nullable(),
    is_accumulator: z.boolean(),
    reset_config_key: z.string().nullable(),
    seed_config_key: z.string().nullable(),
    model_channel_id: deviceModelChannelId.nullable(),
    series_id: timeseriesSeriesId.nullable(),
});
export const deviceChannelInitializer = z.object({
    id: deviceChannelId.optional(),
    device_id: deviceId,
    key: z.string(),
    label: z.string(),
    datatype: deviceChannelDatatypeEnum,
    unit: z.string().optional().nullable(),
    role: deviceChannelRoleEnum,
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    kind: z.string(),
    description: z.string().optional().nullable(),
    min_value: z.number().optional().nullable(),
    max_value: z.number().optional().nullable(),
    default_value: z.number().optional().nullable(),
    is_active: z.boolean().optional(),
    last_seen_at: z.date().optional().nullable(),
    is_accumulator: z.boolean().optional(),
    reset_config_key: z.string().optional().nullable(),
    seed_config_key: z.string().optional().nullable(),
    model_channel_id: deviceModelChannelId.optional().nullable(),
    series_id: timeseriesSeriesId.optional().nullable(),
});
export const deviceChannelMutator = z.object({
    id: deviceChannelId.optional(),
    device_id: deviceId.optional(),
    key: z.string().optional(),
    label: z.string().optional(),
    datatype: deviceChannelDatatypeEnum.optional(),
    unit: z.string().optional().nullable(),
    role: deviceChannelRoleEnum.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    kind: z.string().optional(),
    description: z.string().optional().nullable(),
    min_value: z.number().optional().nullable(),
    max_value: z.number().optional().nullable(),
    default_value: z.number().optional().nullable(),
    is_active: z.boolean().optional(),
    last_seen_at: z.date().optional().nullable(),
    is_accumulator: z.boolean().optional(),
    reset_config_key: z.string().optional().nullable(),
    seed_config_key: z.string().optional().nullable(),
    model_channel_id: deviceModelChannelId.optional().nullable(),
    series_id: timeseriesSeriesId.optional().nullable(),
});
//# sourceMappingURL=DeviceChannel.js.map